<template>
    <div class="tabs-root">
        <div class="tabs-container">
            <div class="tabs" ref="tabs" v-if="data && data.length > 0">
                <div class="item" v-for="(tab, index) in data" :key="index" :class="activeIndex == index ? 'active' : ''"
                    @click="setActiveIndex(tab, index)">
                    {{ tab.label ||  tab.name || tab }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            activeIndex: 0, // 默认激活的tab索引，每次进来都选中第一个
        };
    },
    mounted() {
        this.activeIndex = 0;
        this.scrollToActiveTab(); // 初始化时也滑动到第一个tab
    },
    watch: {
        data() {
            // 每次 data 变化时都默认选中第一个
            this.activeIndex = 0;
            this.scrollToActiveTab();
        }
    },
    methods: {
        setActiveIndex(tab, index) {
            this.activeIndex = index;
            this.$emit("changeTab", tab, index);
            // this.scrollToActiveTab(); // 调用滑动函数
        },
        scrollToActiveTab() {
            this.$nextTick(() => {
                const tabs = this.$refs.tabs;
                if (!tabs) return; // 防止未渲染时报错

                if (this.activeIndex === 0) {
                    tabs.scrollTo({ left: 0, behavior: 'smooth' });
                    return;
                }

                const tabsRect = tabs.getBoundingClientRect();
                const activeTab = tabs.children[this.activeIndex];
                if (!activeTab) return; // 防止越界

                const activeTabRect = activeTab.getBoundingClientRect();

                // 计算当前激活tab之前所有tab的宽度总和
                let widthBeforeAll = 0;
                for (let i = 0; i < this.activeIndex; i++) {
                    widthBeforeAll += tabs.children[i].offsetWidth;
                }

                // 让激活tab居中
                const offSetX = widthBeforeAll + (activeTab.offsetWidth / 2) - (tabsRect.width / 2);

                // 限制滚动范围，防止滚动过头
                const maxScroll = tabs.scrollWidth - tabsRect.width;
                let scrollLeft = Math.max(0, Math.min(offSetX, maxScroll));

                tabs.scrollTo({ left: scrollLeft, behavior: 'smooth' });
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.tabs-root {
    // width: 100%;
    height: 44PX;
    display: flex;
    justify-content: center;

    .tabs-container {
        padding-left: 16PX;
        height: 100%;
        overflow-x: hidden;
        overflow-y: hidden;

        .tabs {
            display: flex;
            flex-direction: row;
            align-items: center;
            overflow-x: auto;
            /* 针对特定元素应用滚动条样式 */


            .item {
                margin-bottom: 16PX;
                margin-right: 16PX;
                cursor: pointer;
                white-space: nowrap;
                // font-family: PingFangSC-Semibold;
                font-size: 14PX;
                text-align: center;
                line-height: 26PX;
                color: rgba(30, 36, 42, 0.8);
                padding-bottom: 6PX;
                transition: all .25s;
                border-bottom: 2px solid transparent;
                font-weight: normal !important;
                
            }

            .active {
                font-weight: 600 !important;
                color: #0F6BF6;
                border-color: #0F6BF6;
            }
        }
    }
}
</style>